import { useState } from "react";
import { useEffect } from "react";
import Storage from "../../services/Storage";
import "./Advert.scss";
// import useDfpSlot from "./useDfpSlots.js";
import { Bling as GPT } from "react-gpt";
import { urlConstants } from "../../utils/urlConstants";
import { useSelector } from "react-redux";
import { Roles } from "../../utils/Roles";

GPT.enableSingleRequest();

function Advert() {
  const { API_URL } = urlConstants;
  const token = Storage.getTokenInCookie("token");

  let userData = useSelector(state => state.UserReducer.userObj);

  // var settings = {
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: false,
  // };

  const adDivId = "ad"
  const [radioValue, setRadioValue] = useState(1);
  // Store ad unit paths as an ARRAY to support dynamic length easily
  const [adPath, setAdPath] = useState([]);
  const [showAdv, setShowAdv] = useState(false);
  const [count, setCount] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    showAd();
  }, []);

  // Keep selected radio button in sync with current count
  useEffect(() => {
    setRadioValue(`ad${count + 1}`);
  }, [count]);

  // Auto-rotate ads every 5s based on dynamic number of ads
  useEffect(() => {
    if (!adPath || adPath.length <= 1) return; // no need to rotate for 0 or 1 ad
    const interval = setInterval(() => {
      setCount((prev) => (prev + 1) % adPath.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [adPath.length]);

  // If ad list changes and current index is out of range, reset to 0
  useEffect(() => {
    if (count >= adPath.length && adPath.length > 0) {
      setCount(0);
    }
  }, [adPath.length]);

  const showAd = () => {
    let googleAddApiUrl = '';
    if (userData?.role === Roles.STUDENT_NAME) {
      googleAddApiUrl = `${API_URL}/api/student/googleads/`;
    } else if (userData?.role === Roles.PARENT_NAME) {
      googleAddApiUrl = `${API_URL}/api/student/googleads/`;
    }
    fetch(googleAddApiUrl, {
      method: "GET",
      headers: {
        "x-authorization": `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Build a dynamic list of active ad unit paths
        const list = Array.isArray(data?.adv_detail)
          ? data.adv_detail
              .filter((item) => item?.status === "active" && item?.path)
              .map((item) => item.path)
          : [];

        setAdPath(list);
        setShowAdv(list.length > 0);
        setCount(0);
      });
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      {showAdv ? (
        <div id={adDivId} className='advSlider adSize'>
          {adPath[count] && (
            <GPT
              adUnitPath={adPath[count]}
              slotSize={[970, 250]}
              sizeMapping={[
                { viewport: [0, 0], slot: [320, 50] },
                { viewport: [750, 0], slot: [970, 250] },
                { viewport: [1050, 0], slot: [970, 250] }
              ]}
            />
          )}
        </div>
      ) : ''}
      <br />
      {windowWidth <= 750 ? "" : (
        adPath.length > 1 && (
          <div className="ad-dots-container">
            {adPath.map((_, i) => (
              <label key={i} style={{ cursor: 'pointer' }}>
                <input
                  type="radio"
                  name="adDots"
                  value={i + 1}
                  checked={radioValue === `ad${i + 1}`}
                  onChange={() => {
                    setRadioValue(`ad${i + 1}`);
                    setCount(i);
                  }}
                />
                {i < adPath.length - 1 && <>&emsp;</>}
              </label>
            ))}
          </div>
        )
      )}
    </>
  );
}

export default Advert;